import {DateFormat} from '../date_format'
import NumberFormatter from '../number_formatter'
import messageResource from '../messageResource'

const dateFormat = new DateFormat(window.SystemSettings.dateFormat)
const numberFormat = new NumberFormatter(window.SystemSettings.decimalSeparator, window.SystemSettings.digitGroupingSymbol, 2, false)

export function columnValue(val, format = (val) => val) {
    return val ? format(val) : ''
}

export function columnValueOrHyphen(val, format = (val) => val) {
    return val !== undefined && val !== null ? format(val) : '-'
}


export function formatDate(val) {
    return dateFormat.formatDate(Date.parseJSONDate(val))
}

export function formatTimeDecimal(val) {
    return numberFormat.format(val / 60)
}

export function formatNumber(val) {
    return numberFormat.format(val)
}

export function formatPercent(val) {
    return formatNumber(val) + '%'
}


export function nameWithArchivedMark(entity) {
    return entity.archived ? entity.name + ' ' + messageResource.getMessage('common.archived') : entity.name
}



// WEBPACK FOOTER //
// ./web/js/csv/format.js